// Task 11 — Toast on live receipt — wired ONCE, in AppShell (the VS shell
// does not mount a general-note toast today; that's a recorded carried
// minor, not wired here). Non-focus-stealing (F-077): plain toast, no modal.
import { useEffect } from "react";
import { useNavigate } from "react-router";
import type { WsClient } from "@/lib/ws-client";
import type { DirectedNoteRecord } from "@capture/shared";
import { toast } from "@/components/Toaster";

export function useDirectedNoteToast(wsClient: WsClient | null): void {
  const navigate = useNavigate();
  useEffect(() => {
    if (!wsClient) return;
    const off = wsClient.onPayload("directed_note", (payload) => {
      const n = payload as DirectedNoteRecord;
      if (!n?.id) return;
      toast.info(
        `Note from ${n.createdByName ?? "a supervisor"}: ${n.body.length > 60 ? `${n.body.slice(0, 60)}…` : n.body}`,
        { label: "Open notes", onClick: () => navigate("/notes") },
      );
    });
    return () => { off(); };
  }, [wsClient, navigate]);
}
